import { Row, Col, Button } from 'antd';

import ErrorImage from 'assets/images/svg/under-construction-img.svg';

import style from './stlye.module.css';

const ErrorComponent = () => {
  return (
    <div className={style.no_package_container}>
      <Row className={style.content_wrapper}>
        <Col span={24}>
          <img src={ErrorImage} alt="error_image" />
        </Col>

        <Col span={24}>
          <p className={style.no_package_text}>
            Diese Seite ist aufgrund von Wartungsarbeiten aktuell nicht
            verfügbar.
          </p>
        </Col>

        <Col span={24}>
          <p className={style.select_on_website_text}>
            Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.
          </p>
        </Col>

        <Col xs={24} xl={6}>
          <Button className={style.go_to_website_button}>
            <a href={'https://www.muenet-glasfaser.de/'}>
              Gehen Sie zur Webseite
            </a>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ErrorComponent;
